import {useState} from "react";
import {Alert} from "antd";
import className from "classnames/bind";
import {Button, FontAwesomeIcon, Loading} from "~/components";
import {useGetLlmsTxtQuery} from "~/reduxs/api/technicalApiSlice";
import style from "../style/Technical.module.scss";

const cn = className.bind(style);

/**
 * Generator llms.txt (GEO): sinh nội dung file llms.txt từ dữ liệu lần crawl mới nhất
 * (backend nhóm trang theo phân đoạn path, kèm title + meta description). Người dùng
 * sao chép hoặc tải file rồi đặt tại thư mục gốc website (https://domain/llms.txt).
 * Tự fetch khi tab được mở (endpoint có 1 request live kiểm tra llms.txt hiện có).
 */
function TechLlms({projectId}) {

	const {data, isLoading, isError, isFetching} = useGetLlmsTxtQuery(projectId);
	const [copied, setCopied] = useState(false);

	if (isLoading || isFetching) return <Loading />;

	if (isError || !data) {
		return <div className={cn('tab')}><p className={cn('muted')}>Không tải được dữ liệu llms.txt.</p></div>;
	}

	if (!data.crawl || !data.content) {
		return (
			<div className={cn('tab')}>
				<div className={cn('empty')}>
					<FontAwesomeIcon icon="fa-light fa-robot" />
					<p>Chưa có dữ liệu crawl để sinh llms.txt. Hãy chạy Site Crawler trước.</p>
				</div>
			</div>
		);
	}

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(data.content);
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		} catch (e) { /* trình duyệt chặn clipboard — người dùng bôi đen copy tay */ }
	};

	const handleDownload = () => {
		const blob = new Blob([data.content], {type: 'text/plain;charset=utf-8'});
		const url = URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = 'llms.txt';
		a.click();
		URL.revokeObjectURL(url);
	};

	return (
		<div className={cn('tab')}>
			<p className={cn('muted')}>
				<strong>llms.txt</strong> là chuẩn mới giúp các AI (ChatGPT, Claude, Perplexity...) nắm nhanh cấu trúc
				và nội dung chính của website — tương tự robots.txt cho công cụ tìm kiếm. Nội dung dưới đây được sinh
				tự động từ {data.pages_used}/{data.pages_total} trang của lần crawl <strong>#{data.crawl.id}</strong>.
				Tải file và đặt tại <code>{(data.project?.root_url || '').replace(/\/$/, '')}/llms.txt</code>.
			</p>

			{data.live_found && (
				<Alert
					type="warning"
					showIcon
					style={{marginBottom: 12}}
					message="Website đã có file llms.txt"
					description="Trang của bạn hiện đã phục vụ /llms.txt. Nội dung sinh bên dưới chỉ là gợi ý — hãy đối chiếu trước khi thay thế file hiện có."
				/>
			)}

			{/* wrap để không tràn ngang trên mobile */}
			<div style={{display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap'}}>
				<Button primary onClick={handleDownload} leftIcon={<FontAwesomeIcon icon="fa-light fa-download" />}>
					Tải llms.txt
				</Button>
				<Button onClick={handleCopy} leftIcon={<FontAwesomeIcon icon={copied ? 'fa-light fa-check' : 'fa-light fa-copy'} />}>
					{copied ? 'Đã sao chép' : 'Sao chép'}
				</Button>
			</div>

			<pre style={{background: '#f6f8fa', border: '1px solid #e5e7eb', borderRadius: 8, padding: 16, maxHeight: 480, overflow: 'auto', fontSize: 13, lineHeight: 1.6, whiteSpace: 'pre-wrap'}}>
				{data.content}
			</pre>
		</div>
	);
}

export default TechLlms;
